// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:20:55.212Z
// Property: Summer Trace at Gulf Shores (ID: 6737460151192640)
// Collections: 27 amenities, 10 floorplans (live), 14 photos, 71 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192640",
  "property_external_id": "4973406",
  "property_zillow_url": "TBD",
  "property_apartments_url": "https://www.apartments.com/summer-trace-at-gulf-shores-gulf-shores-al/qktcbry",
  "property_google_business_url": "https://www.google.com/maps/place/Summer+Trace+at+Gulf+Shores/data=!4m2!3m1!1s0x0:0xb814e05086a12236?sa=X&ved=2ahUKEwjp96W3y7ySAxVM4ckDHSG5Cw4Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321233737",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "summer-trace-at-gulf-shores",
  "property_name": "Summer Trace at Gulf Shores",
  "property_website_url": "https://www.summertraceatgulfshores.com/",
  "property_domain": "https://www.summertraceatgulfshores.com/",
  "property_address": "1569 Island Club Dr",
  "property_full_address": "1569 Island Club Dr, Gulf Shores, AL 36542",
  "property_address_1": "1569 Island Club Dr",
  "property_address_2": null,
  "property_address_city": "Gulf Shores",
  "property_address_state": "AL",
  "property_address_zip_full": "36542-4099",
  "property_address_zip": "36542",
  "property_address_country": "US",
  "property_address_county": "Baldwin County",
  "property_neighborhood_address": "Baldwin County",
  "property_address_latitude": "30.2658602",
  "property_address_longitude": "-87.6943199",
  "property_email": "summertrace@rreafresidential.com",
  "property_phone": "(251) 255-1885",
  "property_call_tracking_phone": "251-714-7224",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Summer Trace at Gulf Shores, where comfort meets convenience! Choose from our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy an array of amenities, including a sparkling pool, state-of-the-art fitness center, and relaxing spa. Why wait? Find your new home today and schedule a tour!",
  "property_long_description": "**Welcome to Summer Trace at Gulf Shores** – where coastal living meets modern luxury! Nestled in the picturesque Gulf Shores, AL, our apartment community offers an array of thoughtfully designed floor plans, including one, two, and three-bedroom options, ensuring the perfect fit for every lifestyle. With stunning amenities that cater to both relaxation and recreation, you’ll fall in love with the vibrant atmosphere right at your doorstep.\n\nDive into our refreshing pool, stay fit in the state-of-the-art fitness center, and unwind in the serene spa after a long day. Our clubhouse is the perfect spot for socializing with friends, while the business center provides a quiet area for productive work sessions. Enjoy the convenience of controlled access, on-site maintenance, and property management, ensuring your experience is seamless and enjoyable.\n\nFor our furry friends, we offer a pet washing station, and you can enjoy quality time with them on the walking and biking trails that weave through our community. Host barbecues at the grill area or catch a movie in our media center. And don’t forget the tennis court for those active afternoons! With features such as a car wash area, lounge, sundeck, storage space, and package service, everything you need is right here.\n\nDiscover the serenity and convenience of Summer Trace at Gulf Shores today. **Find your new home – browse our availability or schedule a tour to see first-hand why our community is the perfect blend of comfort and style!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d4d1d-150f-75c9-b5e2-0e26b72ddb95.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background",
    "public_id": "019d4d1d-150f-75c9-b5e2-0e26b72ddb95",
    "storage_key": "property/6737460151192640/019d4d1d-150f-75c9-b5e2-0e26b72ddb95.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "104",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.07692307692307",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": "80",
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://dlpgulfshores.loftliving.com/login",
  "property_apply_now_url": "https://8873222.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-cacb-738b-8414-794577fad5b3.webp",
  "property_primary_logo_media": {
    "alt_text": "Summer Trace at Gulf Shores logo with sun, ocean waves, and seagulls.",
    "public_id": "019e1ddc-cacb-738b-8414-794577fad5b3",
    "storage_key": "property/6737460151192640/019e1ddc-cacb-738b-8414-794577fad5b3.webp",
    "width": 1920,
    "height": 1440
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e84b9-b113-746e-950b-3bee3f25a844.webp",
  "property_secondary_logo_media": {
    "alt_text": "Summer Trace at Gulf Shores logo with a sun setting over waves and two birds.",
    "public_id": "019e84b9-b113-746e-950b-3bee3f25a844",
    "storage_key": "property/6737460151192640/019e84b9-b113-746e-950b-3bee3f25a844.webp",
    "width": 3072,
    "height": 3072
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-684b-70a8-bb52-2cdda0810bf2.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e1ddd-684b-70a8-bb52-2cdda0810bf2",
    "storage_key": "property/6737460151192640/019e1ddd-684b-70a8-bb52-2cdda0810bf2.webp",
    "width": 1280,
    "height": 960
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-5205-77cd-bf1c-a28dd4757dd9.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e1ddd-5205-77cd-bf1c-a28dd4757dd9",
    "storage_key": "property/6737460151192640/019e1ddd-5205-77cd-bf1c-a28dd4757dd9.webp",
    "width": 1280,
    "height": 960
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "755 - 1347",
  "property_sqft_min": "755",
  "property_sqft_max": "1347",
  "property_price_range": "1239 - 1887",
  "property_price_min": "1239",
  "property_price_max": "1887",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/people/Summer-Trace-at-Gulf-Shores/61554681232832/",
  "property_instagram_url": "https://instagram.com/summer_trace_at_gulf_shores",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJn2W8DNIEmogRNiKhhlDgFLg",
  "property_youtube_url": "https://www.youtube.com/watch?v=Zej1xhg-uMo",
  "property_yelp_url": "https://www.yelp.com/biz/summer-trace-gulf-shores",
  "property_tiktok_url": "https://www.tiktok.com/@summertraceatgulfshores",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Summer Trace at Gulf Shores",
  "property_home_romance_title": "Embrace Your Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Summer Trace at Gulf Shores is a beautiful <a href=\"/floor-plans/\">apartment</a> community located in Gulf Shores, Alabama just minutes from the Gulf of Mexico. You can find nearby shopping, dining, and entertainment options nearby. Take advantage of the outdoors with walking trails and parks not too far from home. This wood-setting neighborhood provides tranquility and convenience, giving you the perfect lifestyle.</p>",
  "property_home_floorplans_blurb": "<p>Located in Gulf Shores, AL, we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Summer Trace at Gulf Shores is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Summer Trace at Gulf Shores, your ideal home awaits with spacious one, two, and three-bedroom floor plans tailored for modern living. Enjoy top-notch amenities like a sparkling pool, fitness center, and serene walking trails. Picture yourself unwinding on your private balcony—this is not just an apartment; it's your sanctuary.",
  "property_home_neighborhood_blurb": "Nestled in picturesque Gulf Shores, AL, Summer Trace offers a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes. Embrace the vibrant neighborhood lifestyle—immerse yourself in local favorites and nearby attractions that make every day an adventure. Come see what's in store for you!",
  "property_home_reviews_blurb": "At Summer Trace in Gulf Shores, you'll find a tranquil haven amid vibrant coastal life. Residents rave about our “quietly peaceful” community, where “management treats you like family.” With pristine grounds, a stunning pool, and easy beach access, your perfect retreat awaits. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Located in Gulf Shores, AL, we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom</a> apartment homes with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Summer Trace at Gulf Shores is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Summer Trace at Gulf Shores in Gulf Shores, AL offers stunning apartment features and <a href=\"/gallery/\">amenities</a>. Our spacious apartments for rent include energy-efficient appliances, smart outlets with USB charging, a washer and dryer, and a balcony or patio. On those hot summer days enjoy the shimmering swimming pool, gather in the clubhouse, and enjoy a stroll through the nearby pet-friendly walking trails. Everything you need and want is right here at our beautiful apartment <a href=\"/neighborhood/\">community</a>.</p>",
  "property_applynow_blurb": "At Summer Trace at Gulf Shores, your dream apartment awaits! Choose from spacious one, two, or three-bedroom floor plans, and enjoy resort-style amenities like a sparkling pool, fitness center, and tennis court. Embrace coastal living with on-site conveniences and vibrant community spaces. Lease your new home online today!",
  "property_contactus_blurb": "At Summer Trace at Gulf Shores, we offer spacious one, two, and three-bedroom floor plans designed with comfort in mind. Enjoy coastal living in our vibrant community nestled in beautiful Gulf Shores, AL. Have questions? Reach out to our dedicated leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Summer Trace at Gulf Shores, we offer thoughtfully designed one, two, and three-bedroom apartments, perfect for your coastal lifestyle. Have questions? Our FAQs page provides clear answers and insights into our vibrant community and amenities, ensuring you feel right at home before you even move in.",
  "property_floorplans_blurb": "<p>Our one, two, and three bedroom apartments for rent are not only spacious but designed with your comfort in mind. Select homes include <a href=\"/amenities/\">unique features</a> such as washer and dryer connections, expansive walk-in closets, granite countertops, luxury wood-designed flooring, and ceiling fans. Relax on your balcony or patio and enjoy the views. Summer Trace at Gulf Shores is pet-friendly and is guaranteed to make you and your pet feel at home.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Welcome to Summer Trace at Gulf Shores, where vibrant living meets modern convenience. Choose from spacious one, two, or three-bedroom floor plans and enjoy top-tier amenities, including a refreshing pool, fitness center, and serene walking trails. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Summer Trace at Gulf Shores, find your perfect home among our inviting one, two, and three-bedroom floor plans. Share the coastal charm and vibrant community with your friends—great friends make great neighbors! Refer a friend today and enhance your summer living experience in beautiful Gulf Shores, AL.",
  "property_residentaccess_blurb": "Welcome to Summer Trace at Gulf Shores, where comfort meets convenience in our thoughtfully designed one, two, and three-bedroom apartments. Residents enjoy seamless access to our portal for easy rent payments and maintenance requests. Log in today and elevate your living experience in beautiful Gulf Shores, AL!",
  "property_reviews_blurb": "At Summer Trace in Gulf Shores, you'll find an oasis of tranquility with a vibrant community. Our residents rave about the delicious blend of serenity and convenience, noting it’s “the perfect place for an affordable, well-kept complex... a nice quiet retreat right in the heart of everything.” Experience the exceptional lifestyle today!",
  "property_created_at": "1752257257936",
  "property_scheduletour_blurb": "At Summer Trace at Gulf Shores, you'll find the perfect blend of comfort and coastal charm with our thoughtfully designed one, two, and three-bedroom floor plans. Experience the vibrant lifestyle of Gulf Shores—schedule a tour today and hear firsthand what makes our community a favorite among residents!",
  "property_thankyou_blurb": "Thank you for reaching out! At Summer Trace at Gulf Shores, you'll find a variety of floor plans designed to suit every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. Our dedicated team is excited to assist you in finding your perfect home in beautiful Gulf Shores, AL.",
  "property_virtualtours_blurb": "<p>At Summer Trace at Gulf Shores, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Summer Trace at Gulf Shores",
  "property_seo_title_home": "Summer Trace at Gulf Shores | Apartments in Gulf Shores, AL",
  "property_seo_description_home": "Experience coastal living at Summer Trace at Gulf Shores, where modern charm meets unmatched amenities. Choose from spacious one, two, or three-bedroom floor plans equipped with everything you need for comfort. Dive into the sparkling pool, break a sweat in our state-of-the-art fitness center, or unwind at the clubhouse. With controlled access and on-site management, your peace of mind is our priority. Enjoy 24-hour access to top-notch facilities including a pet washing station, tennis court, and walking trails. Elevate your lifestyle by finding your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Gulf Shores, AL",
  "property_seo_description_floorplans": "\"Unveil your ideal living space at Summer Trace at Gulf Shores, where coastal charm meets contemporary comfort. Choose from a range of thoughtfully designed floor plans—one, two, or three bedrooms—crafted to suit your lifestyle. Embrace beachside living in Gulf Shores, AL. Browse our available apartment homes today and turn your dream into reality!\"",
  "property_seo_title_amenities": "Amenities | Gulf Shores, AL Apartments for Rent",
  "property_seo_description_amenities": "\"Immerse yourself in the vibrant lifestyle of Summer Trace at Gulf Shores, where coastal charm meets modern convenience. Choose from stylish one, two, or three-bedroom floor plans and enjoy exceptional amenities like a sparkling pool, tennis courts, and a relaxing spa. Whether you’re looking to unwind at our clubhouse or stay active in the fitness center, you'll find everything you need right here in Gulf Shores, AL. Elevate your living experience today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Gulf Shores, AL",
  "property_seo_description_gallery": "\"Immerse yourself in the vibrant lifestyle at Summer Trace at Gulf Shores, where spacious one, two, and three-bedroom apartments await. Picture lounging by the sparkling pool, breaking a sweat in the fitness center, or hosting friends in our inviting clubhouse. With top-notch amenities like a pet washing station, tennis courts, and delightful walking trails, every day feels like a getaway. Browse our photo gallery and envision your ideal life in Gulf Shores, AL—your charming coastal retreat awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Summer Trace at Gulf Shores Apartments",
  "property_seo_description_virtualtours": "Experience coastal living at Summer Trace at Gulf Shores! From cozy one-bedroom retreats to spacious three-bedroom designs, our community offers the perfect floor plan for everyone. Immerse yourself in our vibrant atmosphere and stunning surroundings—take a virtual tour today and envision your life by the beach!",
  "property_seo_title_interactivemap": "Interactive Map | Summer Trace at Gulf Shores Apartments",
  "property_seo_description_interactivemap": "\"Nestled in the heart of Gulf Shores, AL, Summer Trace offers a vibrant lifestyle with stylish one, two, and three-bedroom apartments. Enjoy top-notch amenities like a refreshing pool, state-of-the-art fitness center, and a relaxing spa. Our gated community features walking trails, a movie theater, and a clubhouse perfect for socializing. Use our interactive community map to find your perfect home, check pricing, and make Summer Trace your new haven today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Gulf Shores, AL",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle waiting for you at Summer Trace at Gulf Shores! Nestled in the heart of Gulf Shores, AL, our apartment community places you just steps from local favorites and hidden gems. From stunning one, two, and three-bedroom floor plans to the lively atmosphere of nearby attractions, your perfect neighborhood adventure awaits. Dive into our community and see what makes this coastal paradise special!",
  "property_seo_title_contact": "Contact Us | Summer Trace at Gulf Shores",
  "property_seo_description_contact": "Connect with Summer Trace at Gulf Shores, where coastal living meets comfort in our thoughtfully designed one, two, and three-bedroom apartment floor plans. Nestled in the heart of Gulf Shores, AL, our community offers a perfect blend of relaxation and style. Have questions? Reach out to our leasing team today and let us help you find your ideal home by the beach!",
  "property_seo_title_faqs": "FAQs | Apartments in Gulf Shores, AL",
  "property_seo_description_faqs": "Uncover the lifestyle you've been searching for at Summer Trace at Gulf Shores, where comfort meets convenience in beautiful Gulf Shores, AL. With thoughtful floor plans ranging from one to three bedrooms, our community boasts amenities that cater to your every need—from a refreshing pool and state-of-the-art fitness center to a cozy clubhouse and serene walking trails. Have questions? Our FAQs page is your gateway to discovering everything our exceptional property offers. Join a community designed with you in mind!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Gulf Shores, AL",
  "property_seo_description_reviews": "Experience the vibrant lifestyle of Summer Trace at Gulf Shores, where modern living meets exceptional amenities in the heart of Gulf Shores, AL. With thoughtfully designed one, two, and three-bedroom floor plans, our community boasts a stunning pool, fully-equipped fitness center, and inviting clubhouse—perfect for relaxation and socializing. Explore resident reviews to understand the unparalleled quality of life here and see the joy of living with 24-hour access to amenities like a tennis court, spa, and walking trails. Join our community and find out why Summer Trace is the perfect home for you!",
  "property_seo_title_applynow": "Apply Now | Apartments in Gulf Shores, AL",
  "property_seo_description_applynow": "Elevate your lifestyle at Summer Trace at Gulf Shores, where modern living meets coastal charm. Choose from spacious one, two, or three-bedroom floor plans designed for comfort. Dive into our resort-style amenities, including a shimmering pool, state-of-the-art fitness center, and serene walking trails. Relax in our clubhouse or indulge in spa days—all just steps from your door. Don’t miss the chance to make this vibrant community your new home. Apply online today and embrace a lifestyle of convenience and luxury in beautiful Gulf Shores, AL!",
  "property_seo_title_residentaccess": "Resident Access | Summer Trace at Gulf Shores",
  "property_seo_description_residentaccess": "\"Unlock the full potential of your living experience at Summer Trace at Gulf Shores! Access your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with our vibrant community. Your convenience awaits!\"",
  "property_seo_title_referafriend": "Refer A Friend | Summer Trace at Gulf Shores",
  "property_seo_description_referafriend": "\"Transform your circles into neighbors at Summer Trace at Gulf Shores! Share the joy of coastal living and refer a friend today—great friendships make our vibrant community even better. Join us by the sea!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Summer Trace at Gulf Shores",
  "property_seo_description_scheduletour": "\"Step into your coastal haven at Summer Trace at Gulf Shores! Schedule a tour today to experience the vibrant charm and serene ambiance of our apartment community, where beachside living meets modern comfort. Your dream home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Summer Trace at Gulf Shores",
  "property_seo_description_privacy": "\"At Summer Trace at Gulf Shores, your privacy is our priority. Dive into our comprehensive privacy policy to learn how we protect your personal information while you enjoy our vibrant community in the heart of Gulf Shores, AL. Your trust matters—read more today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Summer Trace at Gulf Shores",
  "property_seo_description_accessibility": "\"At Summer Trace at Gulf Shores, we prioritize digital inclusion and accessibility for all residents. Learn how our community is designed to be welcoming and user-friendly, ensuring that everyone can easily navigate their home and surroundings. Engage with us today!\"",
  "property_seo_title_sitemap": "Sitemap | Summer Trace at Gulf Shores",
  "property_seo_description_sitemap": "\"Navigate your way to your ideal home at Summer Trace at Gulf Shores! Our comprehensive sitemap makes it easy to uncover every facet of our vibrant community in sunny Alabama. From luxurious amenities to local attractions, everything you need is just a click away.\"",
  "property_seo_title_thankyou": "Thank You | Summer Trace at Gulf Shores",
  "property_seo_description_thankyou": "Thank you for reaching out to Summer Trace at Gulf Shores! Your journey to coastal living in Alabama has officially begun. A member of our friendly team will get in touch soon to help you discover your ideal home by the beautiful Gulf. Stay tuned for an exciting new chapter in seaside comfort! 🌊🏖️",
  "property_seo_title_pets": "Pet Policy | Apartments in Gulf Shores, AL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558440",
  "amenities": [
    {
      "id": "custom_21372700-a777-4611-892c-7d42f1b16ef6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Self Serve Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_abcab119-dedb-4c68-b9a3-e02c9cdfe653",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8857e7c4-5edb-46a5-8f19-e060148f9f7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Flex (Flexible Payments Options)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5cb75763-33c8-493c-9dcb-fcc1106849be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Free Wi‑Fi Access in Common Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_141b367f-fd3f-4679-bd21-90188c72f17a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑circuit Fitness Center With Cardio Equipment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_355eba72-1bb5-43d5-9bd0-372d4f8a25d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Stations and Social Terrace",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b807afba-8ba7-4aab-9c14-16bf6d6e81ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Management and Service Teams",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8894206b-b6c0-4b91-a5e6-08d7aedfb566",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑friendly Walking Trails",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2496be15-68ec-416a-a5f6-87edc93ea0bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60192cd2-62f9-49f1-a7e2-9b11c79dcb28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16fe08a9-e76a-4a5d-a6b6-0a472e400c98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_272ffe8d-0c30-4bf4-be49-7a0c03fc8709",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool With Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e806e8bb-533d-489c-b45c-ae247f469059",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish Lobby and Management Office",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b393ed5-9963-4515-9013-06cd63d4bb6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1dbba111-1c35-4e6b-8a0c-8c19999104de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_501f6752-86e9-4f5b-8abc-c083d9791c53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑ready Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4cc9cd60-a5ba-4ed9-a9d9-5c3fc339b051",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Cabinetry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5ca171f-6b14-48ec-befc-b6840851d8aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe0a8fe2-8722-464d-a4f9-4aca0c9aa054",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_faeb16ad-778d-448f-ad5c-cc222f2767d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Energy‑efficient Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00c6a0b0-5e6f-4f2c-9865-b4b6ebbe010b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑in Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36e551ab-51b0-4e86-803f-1233d8e14ac0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Luxury Wood Designed Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42a8785d-b4d0-4618-8e3a-cad8e628b56b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcd31bb4-4fd5-456c-84a7-68e42c665228",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Open Concept Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38ccd75a-51ce-40f4-99bd-b400b91675b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3cb746dc-210d-437d-b002-bee67ffb3a03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a213ffb1-51df-427a-84cb-85cf7b1c9dc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Included*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d24a5029-9c2b-4998-9e60-830149843a59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e84ba-77af-7613-96b6-0738b3e51ca6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables",
        "public_id": "019e84ba-77af-7613-96b6-0738b3e51ca6",
        "storage_key": "property/6737460151192640/019e84ba-77af-7613-96b6-0738b3e51ca6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94e249dd-f2c0-4534-a811-fe5f1c2bfe5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-ddbe-73d8-8cc4-0251745492c7.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, two chairs, coffee table, and nautical-themed art.",
        "public_id": "01a09173-ddbe-73d8-8cc4-0251745492c7",
        "storage_key": "property/6737460151192640/01a09173-ddbe-73d8-8cc4-0251745492c7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a comfortable sofa, accent chairs, and a coffee table, decorated with serene nautical-themed artwork.",
      "link": "",
      "alt_text": "Living room with a sofa, two chairs, coffee table, and nautical-themed art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ab53ad2-6bf0-4b2a-a179-4715126643cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-dd75-74ed-b507-fb4dc4d0b484.webp",
      "image_media": {
        "alt_text": "Dining area and living room with modern furniture and decor.",
        "public_id": "01a09173-dd75-74ed-b507-fb4dc4d0b484",
        "storage_key": "property/6737460151192640/01a09173-dd75-74ed-b507-fb4dc4d0b484.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy a bright and airy open-concept living space, perfect for entertaining or relaxing. This apartment features a stylish dining area and a comfortable living room.",
      "link": "",
      "alt_text": "Dining area and living room with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f732973-b4b4-4aec-b8d8-b5596d8e2f45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-d78e-74f2-9f92-8a3fa5d6fd55.webp",
      "image_media": {
        "alt_text": "A spacious bedroom with a large bed, dresser, and mirror.",
        "public_id": "01a09173-d78e-74f2-9f92-8a3fa5d6fd55",
        "storage_key": "property/6737460151192640/01a09173-d78e-74f2-9f92-8a3fa5d6fd55.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a king-sized bed, ample storage, and a decorative mirror.",
      "link": "",
      "alt_text": "A spacious bedroom with a large bed, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9107b86e-278e-470c-909f-ef38d4948b67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-db6a-7347-9075-6904bba18bef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and subway tile backsplash.",
        "public_id": "01a09173-db6a-7347-9075-6904bba18bef",
        "storage_key": "property/6737460151192640/01a09173-db6a-7347-9075-6904bba18bef.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring black appliances, ample cabinet space, and a stylish subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19db65c1-ff8d-45a1-b98b-8fde11517521",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-ddcf-7413-928b-0a917e2cffda.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel sink, coffee maker, and granite countertops.",
        "public_id": "01a09173-ddcf-7413-928b-0a917e2cffda",
        "storage_key": "property/6737460151192640/01a09173-ddcf-7413-928b-0a917e2cffda.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "View of a bright and modern kitchen featuring a double basin stainless steel sink, granite countertops, and a coffee maker, perfect for morning routines.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel sink, coffee maker, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b3fcd3d-7730-4323-8277-f8b0c6fbfc9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-d778-74ae-8ac5-b6d108e58a4a.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, TV, and comfortable seating.",
        "public_id": "01a09173-d778-74ae-8ac5-b6d108e58a4a",
        "storage_key": "property/6737460151192640/01a09173-d778-74ae-8ac5-b6d108e58a4a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, perfect for entertaining or cozy nights in.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace, TV, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cef2a81-fb4c-4b5d-8cc0-4bebd1dc0dce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-d780-75fa-96b0-900c32306632.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, ottoman, and chairs, with a view of the pool through the windows.",
        "public_id": "01a09173-d780-75fa-96b0-900c32306632",
        "storage_key": "property/6737460151192640/01a09173-d780-75fa-96b0-900c32306632.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this bright and airy living room, featuring comfortable seating and large windows overlooking the sparkling pool. Perfect for entertaining or unwinding after a long day.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, ottoman, and chairs, with a view of the pool through the windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c290445-98fd-4210-879d-a0c84710340a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-d786-703c-8b06-66f31c5847de.webp",
      "image_media": {
        "alt_text": "Community lounge area with comfortable seating and view of the pool.",
        "public_id": "01a09173-d786-703c-8b06-66f31c5847de",
        "storage_key": "property/6737460151192640/01a09173-d786-703c-8b06-66f31c5847de.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, offering comfortable seating and a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Community lounge area with comfortable seating and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1bab3b8e-7a4a-430a-9548-4107dfc0310e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-d70a-7398-ba0a-f9d98157965b.webp",
      "image_media": {
        "alt_text": "Walk-in closet next to a bedroom with a queen-sized bed and nightstand.",
        "public_id": "01a09173-d70a-7398-ba0a-f9d98157965b",
        "storage_key": "property/6737460151192640/01a09173-d70a-7398-ba0a-f9d98157965b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet adjacent to the master bedroom, offering ample storage space.",
      "link": "",
      "alt_text": "Walk-in closet next to a bedroom with a queen-sized bed and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ca9cbf9-b5dc-40c4-a1d5-8790d46c25fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/01a09173-db7a-763a-9dec-297bfde45310.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with white tub, toilet, vanity, and mirror.",
        "public_id": "01a09173-db7a-763a-9dec-297bfde45310",
        "storage_key": "property/6737460151192640/01a09173-db7a-763a-9dec-297bfde45310.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our apartment bathrooms, featuring a clean white tub, toilet, and a sleek vanity with ample counter space and a large mirror.",
      "link": "",
      "alt_text": "Modern apartment bathroom with white tub, toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d755ec4a-4620-42b2-95c4-2e446dbfefef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e84ba-3ead-71e9-bde9-da6538227cd7.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and a TV screen.",
        "public_id": "019e84ba-3ead-71e9-bde9-da6538227cd7",
        "storage_key": "property/6737460151192640/019e84ba-3ead-71e9-bde9-da6538227cd7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring modern cardio machines and a wall-mounted television for your entertainment.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and a TV screen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f452a217-d54c-4e34-b0b2-43c8c6416570",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e84ba-4308-705a-a342-b81b0f5d4716.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two built-in grills, a stone base, and seating area with a table and umbrella.",
        "public_id": "019e84ba-4308-705a-a342-b81b0f5d4716",
        "storage_key": "property/6737460151192640/019e84ba-4308-705a-a342-b81b0f5d4716.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community grilling station, complete with two grills and a shaded seating area perfect for dining al fresco.",
      "link": "",
      "alt_text": "Outdoor grilling station with two built-in grills, a stone base, and seating area with a table and umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7be156fe-6535-483b-92d9-81ca65195f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e84b9-c4af-7307-bc8a-b4a57f7c9b01.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and grey tiled backsplash.",
        "public_id": "019e84b9-c4af-7307-bc8a-b4a57f7c9b01",
        "storage_key": "property/6737460151192640/019e84b9-c4af-7307-bc8a-b4a57f7c9b01.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, a sleek black stove and refrigerator, and elegant grey subway tile backsplash. Includes a double sink and a dishwasher.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and grey tiled backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b00f498d-9e8b-4c2a-8e05-141aade1cf2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Original Oyster House Boardwalk",
      "poi_type": "Restaurants",
      "poi_address": "701 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Gulf & Southern-style seafood, plus a kids' menu, in wood-paneled digs with a laid-back vibe.",
      "poi_long_description": "Gulf & Southern-style seafood, plus a kids' menu, in wood-paneled digs with a laid-back vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b0d2-7269-997f-0b2772e15e16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b0d2-7269-997f-0b2772e15e16",
        "storage_key": "property/6737460151192640/019e1dde-b0d2-7269-997f-0b2772e15e16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.originaloysterhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6646074719514320050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "original-oyster-house-boardwalk",
      "poi_latitude": "30.2545635",
      "poi_longitude": "-87.68913859999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-948-2445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5giJsgEmogRstxat76ZO1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_3bdc38d3-807d-47ae-b17b-b515387cf91b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "LuLu's Gulf Shores",
      "poi_type": "Restaurants",
      "poi_address": "200 E 25th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Vibrant eatery featuring hearty burgers, seafood dishes & sandwiches, plus cocktails, beer & wine.",
      "poi_long_description": "Vibrant eatery featuring hearty burgers, seafood dishes & sandwiches, plus cocktails, beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-b805-75bf-9c1b-375201b1cc8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-b805-75bf-9c1b-375201b1cc8b",
        "storage_key": "property/6737460151192640/019e1ddc-b805-75bf-9c1b-375201b1cc8b.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://lulusfunfoodmusic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12108597633711140753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lulus-gulf-shores",
      "poi_latitude": "30.280065",
      "poi_longitude": "-87.6851621",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-967-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Y9S8SYFmogRke98zWRhCqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f80746db-7442-4359-9bba-e8f68cb4f12f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Bahama Bob's Beach Side Cafe",
      "poi_type": "Restaurants",
      "poi_address": "601 W Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Seafood shack amid the sand dunes serving Caribbean & Southern-style eats steps from the water.",
      "poi_long_description": "Seafood shack amid the sand dunes serving Caribbean & Southern-style eats steps from the water.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-abf0-712f-8f75-92085f557ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-abf0-712f-8f75-92085f557ac8",
        "storage_key": "property/6737460151192640/019e1dde-abf0-712f-8f75-92085f557ac8.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "http://www.bahamabobs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5659203145130632942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bahama-bobs-beach-side-cafe",
      "poi_latitude": "30.2463987",
      "poi_longitude": "-87.6986501",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-948-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9uFwkwbmogR7uZI2UaHiU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_6a3ce40f-1c56-4c23-b745-78500ec24a54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Tacky Jacks Gulf Shores",
      "poi_type": "Restaurants",
      "poi_address": "240 E 24th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Breezy waterfront eatery specializing in seafood, plus bar bites, beers & live music.",
      "poi_long_description": "Breezy waterfront eatery specializing in seafood, plus bar bites, beers & live music.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJZQQ0OicFmogRY_Wk7X98pQ0/photos/Ab43m-vRL4mUdeeldP6YgTXxxSgUq2Qd5IvgzMXLYhEakxUE3hVuUs9uliOQdJ2ZaTX9J2xQEzjIsVaCNWV4vUBM3Np1eSGbfAFGC5G0uGRzKhCiEHNM9Ei1gexgn8u2LQmFZokwpvi3QHxllt95V3aY3fk6QRGfh9OK1JP3-O0KMIRej_yAfy7GXDZUjGecuLYwkT_t00_zkm84RxDSadlz-SaypoxQLlhW3_7plt5woASP_1-tRqmvK5SOj_oo3MBi_jeIHc2iwJ7TwvxZea_2IJdNb8933BJNLNzVtqGzJRg5BabcBUOM5GTNffSn_NkMRA8kzUMfyg5p3pA42VuWZQ1ssC4fjrSa1cuxeb22-3ob7zU_DHzyQj0V6lI-OLOtvneONwkxLeOjutTbkPJw8BBS4IKjrHpLUqFo0H1NTQOu95j3/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4452&maxHeightPx=4800",
      "poi_featured_image_media": null,
      "poi_business_url": "http://tackyjacks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=983328982540023139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacky-jacks-gulf-shores",
      "poi_latitude": "30.2787094",
      "poi_longitude": "-87.6836932",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-948-8881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQQ0OicFmogRY_Wk7X98pQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_2eff2076-4002-47eb-9afd-4023518fc28e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Big Beach Brewing",
      "poi_type": "Restaurants",
      "poi_address": "300 E 24th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-abcc-738c-b1e9-046681fd89d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-abcc-738c-b1e9-046681fd89d4",
        "storage_key": "property/6737460151192640/019e1dde-abcc-738c-b1e9-046681fd89d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bigbeachbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18257357647487987834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-beach-brewing",
      "poi_latitude": "30.2782115",
      "poi_longitude": "-87.6828105",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-948-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWvLtCAFmogRenDIewwqX_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_f51c72e2-603c-4b8a-bcc4-702fb91c572f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Sunliner Diner - Gulf Shores",
      "poi_type": "Restaurants",
      "poi_address": "100 E 2nd Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Burgers, shakes & sandwiches, plus all-day breakfast are on offer at this bright 50s-style diner.",
      "poi_long_description": "Burgers, shakes & sandwiches, plus all-day breakfast are on offer at this bright 50s-style diner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-a8df-703f-8040-c502d35955be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a8df-703f-8040-c502d35955be",
        "storage_key": "property/6737460151192640/019e1ddc-a8df-703f-8040-c502d35955be.webp",
        "width": 889,
        "height": 659
      },
      "poi_business_url": "https://www.sunlinerdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13809422056732433362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunliner-diner---gulf-shores",
      "poi_latitude": "30.2507962",
      "poi_longitude": "-87.6890452",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-937-6590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1NkDLcEmogR0hv79DHspL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_50d12bbc-cdab-4702-8e29-99d5969accfd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Kitty's Kafe",
      "poi_type": "Restaurants",
      "poi_address": "3800 Gulf Shores Pkwy #100, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Cozy nook with homey decor offering simple comfort fare like biscuits & gravy & country fried steak.",
      "poi_long_description": "Cozy nook with homey decor offering simple comfort fare like biscuits & gravy & country fried steak.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-ae09-75ea-a5d7-e51ea288a1f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-ae09-75ea-a5d7-e51ea288a1f4",
        "storage_key": "property/6737460151192640/019e1dde-ae09-75ea-a5d7-e51ea288a1f4.webp",
        "width": 550,
        "height": 412
      },
      "poi_business_url": "http://www.kittyskafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17481950610786452452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kittys-kafe",
      "poi_latitude": "30.3027913",
      "poi_longitude": "-87.68006380000001",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-948-5233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3WAh2UMFmogR5IPZCHVdnPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_18c52b67-73d2-4ce0-a548-e61edff51a06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "De Soto's Seafood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "138 W 1st Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Kitchen dishing out a diverse lineup of seafood & sides in a casual, airy setting.",
      "poi_long_description": "Kitchen dishing out a diverse lineup of seafood & sides in a casual, airy setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b141-7210-9bf3-01d856111673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b141-7210-9bf3-01d856111673",
        "storage_key": "property/6737460151192640/019e1dde-b141-7210-9bf3-01d856111673.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.desotosseafoodkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3392850795758768081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "de-sotos-seafood-kitchen",
      "poi_latitude": "30.24954769999999",
      "poi_longitude": "-87.6914411",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-948-7294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaym-x7YEmogR0U8amdLTFS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_116aee14-6bfb-41c8-95cf-ab15df4cf7ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Sea N Suds",
      "poi_type": "Restaurants",
      "poi_address": "405 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Beachgoers savor seafood paired with cold brews in a rustic joint steps from the Gulf.",
      "poi_long_description": "Beachgoers savor seafood paired with cold brews in a rustic joint steps from the Gulf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b13e-771f-8cd6-6c09ef63eca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b13e-771f-8cd6-6c09ef63eca2",
        "storage_key": "property/6737460151192640/019e1dde-b13e-771f-8cd6-6c09ef63eca2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sea-n-suds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17570013434260370281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-n-suds",
      "poi_latitude": "30.24814319999999",
      "poi_longitude": "-87.68088519999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-948-7894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VNVkr4EmogRaTPu5yA61fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_3013764c-8766-45f3-8a2f-cecd01f19011",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Woodside Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "20249 State Park Rd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Classic dishes served in a laid-back venue in a state park, plus an expansive garden & live music.",
      "poi_long_description": "Classic dishes served in a laid-back venue in a state park, plus an expansive garden & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b44f-736d-a4b3-ee0cc61eff10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b44f-736d-a4b3-ee0cc61eff10",
        "storage_key": "property/6737460151192640/019e1dde-b44f-736d-a4b3-ee0cc61eff10.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://woodsideatgsp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17458131175984531201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodside-restaurant",
      "poi_latitude": "30.2667117",
      "poi_longitude": "-87.6795341",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-923-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XYsPq4FmogRAQe7ss69R_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b4c04b53-1ae9-4fb0-9470-882a8edab925",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Bywater Beachside",
      "poi_type": "Restaurants",
      "poi_address": "20800 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Casual beach bar and grill offering pizza, beer, and wine, plus karaoke on Fridays.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-acfb-7540-ba63-071853e42671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-acfb-7540-ba63-071853e42671",
        "storage_key": "property/6737460151192640/019e1dde-acfb-7540-ba63-071853e42671.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17119616178582835686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bywater-beachside",
      "poi_latitude": "30.2489082",
      "poi_longitude": "-87.66752559999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46d-71c0-bf96-a917d7d18e01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46d-71c0-bf96-a917d7d18e01",
        "storage_key": "property/6737460151192640/019e1dde-f46d-71c0-bf96-a917d7d18e01.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-E8Go0EmogR5tF19zUYle0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_7410c044-ec24-42b6-b2c4-5cb019cbe82d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Sassy Bass Amazin' Grill",
      "poi_type": "Restaurants",
      "poi_address": "5160 AL-180, Gulf Shores, AL 36542, USA",
      "poi_short_description": "This colorful, beach-themed joint with live music features seafood plates & tropical cocktails.",
      "poi_long_description": "This colorful, beach-themed joint with live music features seafood plates & tropical cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b119-72db-8b49-3aff0aee19a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b119-72db-8b49-3aff0aee19a7",
        "storage_key": "property/6737460151192640/019e1dde-b119-72db-8b49-3aff0aee19a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sassybass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11447595110299024460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sassy-bass-amazin-grill",
      "poi_latitude": "30.2333514",
      "poi_longitude": "-87.9330006",
      "poi_miles_from_property": "15",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 251-975-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnd--NlUhmogRTDzf0RkH3p4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e24ac7fd-a682-4172-b6f0-03d95f35a873",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Tin Top Restaurant & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "17451 County Rd 49 S, Bon Secour, AL 36511, USA",
      "poi_short_description": "No-frills bayside destination for choice seafood, large oysters & classic fried green tomatoes.",
      "poi_long_description": "No-frills bayside destination for choice seafood, large oysters & classic fried green tomatoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-a993-7248-a232-caab4a952844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a993-7248-a232-caab4a952844",
        "storage_key": "property/6737460151192640/019e1ddc-a993-7248-a232-caab4a952844.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tintoprestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11298239525497669506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tin-top-restaurant--oyster-bar",
      "poi_latitude": "30.311489",
      "poi_longitude": "-87.7259924",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 251-949-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJefev2IUamogRggeR4Pxoy5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "oyster_bar_restaurant"
    },
    {
      "id": "custom_5b305248-8ace-43b2-a428-abdf03cb8ee7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "King Neptune's Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1137 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Local spot known for steamed royal red shrimp & other Gulf seafood dishes served in a rustic nook.",
      "poi_long_description": "Local spot known for steamed royal red shrimp & other Gulf seafood dishes served in a rustic nook.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b4ab-75fc-9e10-68206288567a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b4ab-75fc-9e10-68206288567a",
        "storage_key": "property/6737460151192640/019e1dde-b4ab-75fc-9e10-68206288567a.webp",
        "width": 626,
        "height": 417
      },
      "poi_business_url": "https://kingneptunes.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313426490850445648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-neptunes-seafood-restaurant",
      "poi_latitude": "30.261329",
      "poi_longitude": "-87.688859",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-968-5464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQLUiakYmogRUIlWmruDWQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f4fc5e8f-4c05-4f20-bf8a-3c3203adbf50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Island Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Convenience store chain outlet supplying beach and other necessities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b69e-7601-807c-aa3d9b76c63f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b69e-7601-807c-aa3d9b76c63f",
        "storage_key": "property/6737460151192640/019e1dde-b69e-7601-807c-aa3d9b76c63f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.surfstyle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5501259147767376442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-market",
      "poi_latitude": "30.2498521",
      "poi_longitude": "-87.6811254",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-924-9779 ext. 203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f48d-70cb-a272-d52cda7362c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f48d-70cb-a272-d52cda7362c2",
        "storage_key": "property/6737460151192640/019e1dde-f48d-70cb-a272-d52cda7362c2.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJsZRc7b4EmogROuoKSAxmWEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_3164b311-b0f7-42d2-8bea-4dce411f9cd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "170 Fort Morgan Road, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Busy chain that sells a large variety of goods, including groceries and hardware.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b75d-75a6-87a5-bac2c87c360b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b75d-75a6-87a5-bac2c87c360b",
        "storage_key": "property/6737460151192640/019e1dde-b75d-75a6-87a5-bac2c87c360b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2748-gulf-shores-al/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15285383047105269148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.2673384",
      "poi_longitude": "-87.68615659999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg9iMWsUEmogRnM18WuWWINQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f7aa8852-fa79-435e-af2c-3b134995232f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Rouses Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1549 Gulf Shores Pkwy Suite 1150, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_long_description": "Supermarket chain offering produce, meat & seafood, plus grab-&-go dinners & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-b306-706e-83f7-4e4da13b952b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-b306-706e-83f7-4e4da13b952b",
        "storage_key": "property/6737460151192640/019e1ddc-b306-706e-83f7-4e4da13b952b.webp",
        "width": 1280,
        "height": 1078
      },
      "poi_business_url": "https://www.rouses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4668396340053696913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rouses-market",
      "poi_latitude": "30.2660022",
      "poi_longitude": "-87.69011580000002",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-948-4715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e73-70cf-8e2c-6081e3504ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e73-70cf-8e2c-6081e3504ded",
        "storage_key": "property/6737460151192640/019e1ddd-3e73-70cf-8e2c-6081e3504ded.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6jzK9AEmogRkWGir7x5yUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c59430b7-aacd-4e00-9548-a20e28a75af8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Publix Super Market at Colonial Promenade at Craft Farms",
      "poi_type": "Shopping & Retail",
      "poi_address": "160 Cotton Creek Dr Ste 100, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-ab97-71be-bb56-8e1107d3b94a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-ab97-71be-bb56-8e1107d3b94a",
        "storage_key": "property/6737460151192640/019e1ddc-ab97-71be-bb56-8e1107d3b94a.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1292&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=4133776225617508110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-colonial-promenade-at-craft-farms",
      "poi_latitude": "30.298598",
      "poi_longitude": "-87.6813592",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-948-1281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e73-70cf-8e2c-6081e3504ded.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e73-70cf-8e2c-6081e3504ded",
        "storage_key": "property/6737460151192640/019e1ddd-3e73-70cf-8e2c-6081e3504ded.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXxkcgsFmogRDvfiVJMfXjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_7b307eda-1518-4486-95d9-3f3de8b9963f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "3820 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15008237667783179477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "30.3039831",
      "poi_longitude": "-87.6800148",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-967-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____o0EFmogR1XzaTKT4R9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_77c27901-637a-4903-8864-0de905bce275",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1421 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b793-715a-af13-b42c07d41471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b793-715a-af13-b42c07d41471",
        "storage_key": "property/6737460151192640/019e1dde-b793-715a-af13-b42c07d41471.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1421+gulf+shores+pkwy-gulf+shores-al-36542/id=1230",
      "poi_directions_map_url": "https://maps.google.com/?cid=14764018774743324292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.263747",
      "poi_longitude": "-87.68930379999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-968-5946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXft5lM8EmogRhBbGPdpU5Mw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c8e5973b-545c-4240-8745-409b75a24b21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3820 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b9b1-70b5-a0a2-9de18e0ad77c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b9b1-70b5-a0a2-9de18e0ad77c",
        "storage_key": "property/6737460151192640/019e1dde-b9b1-70b5-a0a2-9de18e0ad77c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.target.com/sl/gulf-shores/2154",
      "poi_directions_map_url": "https://maps.google.com/?cid=6743911853304642931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.3039831",
      "poi_longitude": "-87.6800148",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-967-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR8VZ1EYFmogRc_3EjBkwl10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9e46c1cc-9c63-41a6-95c3-9d1ebf4bc725",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Beach House Boutique",
      "poi_type": "Shopping & Retail",
      "poi_address": "3800 Gulf Shores Pkwy #320, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Charming boutique in breezy quarters stocking resort wear, designer swimsuits, shoes & accessories.",
      "poi_long_description": "Charming boutique in breezy quarters stocking resort wear, designer swimsuits, shoes & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-bd33-760d-ae9c-c5f89eb8dec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-bd33-760d-ae9c-c5f89eb8dec5",
        "storage_key": "property/6737460151192640/019e1dde-bd33-760d-ae9c-c5f89eb8dec5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://shopthebeachlife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16239947593395289631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beach-house-boutique",
      "poi_latitude": "30.30147509999999",
      "poi_longitude": "-87.681467",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-948-7467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt5WsAUQFmogRHz5JE0viX-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_70bfc82a-1898-43ac-aade-bca947247d74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Books-A-Million",
      "poi_type": "Shopping & Retail",
      "poi_address": "3800 Gulf Shores Pkwy Suite 430, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Large chain bookstore stocking a range of titles for adults & kids, plus toys & games.",
      "poi_long_description": "Large chain bookstore stocking a range of titles for adults & kids, plus toys & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-bcf3-73b9-a37b-71d77253c4b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-bcf3-73b9-a37b-71d77253c4b8",
        "storage_key": "property/6737460151192640/019e1dde-bcf3-73b9-a37b-71d77253c4b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.booksamillion.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb-421",
      "poi_directions_map_url": "https://maps.google.com/?cid=3407531608144703899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "books-a-million",
      "poi_latitude": "30.302298",
      "poi_longitude": "-87.6817037",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-968-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJt5WsAUQFmogRm3FhmPH7SS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_75e44148-6353-41b6-b2aa-84aed8a0895b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 E 3rd St, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gsboe.org/gses",
      "poi_directions_map_url": "https://maps.google.com/?cid=16341929703308785902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-elementary-school",
      "poi_latitude": "30.2690791",
      "poi_longitude": "-87.6797474",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-968-7375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf1tMQdwEmogR7vgfXnsyyuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b3c93475-753c-4cc1-81c2-d8ba740f3a74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Middle School",
      "poi_type": "Education",
      "poi_address": "450 E 15th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-bb41-746b-9fde-56a159abd3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-bb41-746b-9fde-56a159abd3e8",
        "storage_key": "property/6737460151192640/019e1dde-bb41-746b-9fde-56a159abd3e8.webp",
        "width": 1280,
        "height": 515
      },
      "poi_business_url": "https://www.gsboe.org/gsms",
      "poi_directions_map_url": "https://maps.google.com/?cid=6516070705618627382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-middle-school",
      "poi_latitude": "30.2688746",
      "poi_longitude": "-87.6795293",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-8719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIy0fCtsEmogRNiu6e8i7bVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_657d3f39-8f44-41f8-9aa6-655735fde623",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores High School",
      "poi_type": "Education",
      "poi_address": "600 E 15th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-ba8f-727f-959d-3794a29bc874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-ba8f-727f-959d-3794a29bc874",
        "storage_key": "property/6737460151192640/019e1dde-ba8f-727f-959d-3794a29bc874.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gshs.gsboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4433622775151596733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-high-school",
      "poi_latitude": "30.2685775",
      "poi_longitude": "-87.6753245",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-968-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ__8I_uYEmogRvRT-dGxkhz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a1a2888c-9fd5-400d-a6b9-b0f38edae428",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Coastal Alabama Community College: Gulf Shores Campus",
      "poi_type": "Education",
      "poi_address": "3301 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-c74b-7154-8928-922d71288994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-c74b-7154-8928-922d71288994",
        "storage_key": "property/6737460151192640/019e1ddc-c74b-7154-8928-922d71288994.webp",
        "width": 1280,
        "height": 601
      },
      "poi_business_url": "https://www.coastalalabama.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733699067929643783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-alabama-community-college-gulf-shores-campus",
      "poi_latitude": "30.2891209",
      "poi_longitude": "-87.6861287",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-968-3104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO-HWzjoFmogRB0vjxW7C9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6d6aea0f-3c0c-4372-bab7-220636e2fa96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Orange Beach Elementary School",
      "poi_type": "Education",
      "poi_address": "4900 S Wilson Blvd, Orange Beach, AL 36561, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c397-717e-b2d5-513a3458c5d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c397-717e-b2d5-513a3458c5d1",
        "storage_key": "property/6737460151192640/019e1dde-c397-717e-b2d5-513a3458c5d1.webp",
        "width": 1280,
        "height": 691
      },
      "poi_business_url": "http://www.obschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2587181983962929861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-beach-elementary-school",
      "poi_latitude": "30.2969208",
      "poi_longitude": "-87.5579546",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 251-981-5662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPc5Ja5UHmogRxZpmk06E5yM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bc597f57-e752-4eab-af69-d16501903c07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Orange Beach Middle & High School",
      "poi_type": "Education",
      "poi_address": "23908 Canal Rd, Orange Beach, AL 36561, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c1fe-75cc-b09e-2e8c0e657806.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c1fe-75cc-b09e-2e8c0e657806",
        "storage_key": "property/6737460151192640/019e1dde-c1fe-75cc-b09e-2e8c0e657806.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.obcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13321809918028115423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orange-beach-middle--high-school",
      "poi_latitude": "30.2894112",
      "poi_longitude": "-87.61535889999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-967-5306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUaP1cAAHmogR321X2YmT4Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_b7bb29a4-f14f-4ae6-8b0b-ecf63f73041d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Discovery Island Child Development",
      "poi_type": "Education",
      "poi_address": "24843 Commercial Ave, Orange Beach, AL 36561, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c2d4-756f-8211-587d08a91a34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c2d4-756f-8211-587d08a91a34",
        "storage_key": "property/6737460151192640/019e1dde-c2d4-756f-8211-587d08a91a34.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.discoveryislandcdc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4937314754605258880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-island-child-development",
      "poi_latitude": "30.29070549999999",
      "poi_longitude": "-87.5993132",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 251-974-5488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-z1r0GkGmogRgJiKPJzdhEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_a05f8eca-53eb-4450-9668-73b03a3485f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Holy Spirit Episcopal Church",
      "poi_type": "Education",
      "poi_address": "616 W Fort Morgan Rd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c09a-727b-a2bd-16d82e5514eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c09a-727b-a2bd-16d82e5514eb",
        "storage_key": "property/6737460151192640/019e1dde-c09a-727b-a2bd-16d82e5514eb.webp",
        "width": 480,
        "height": 321
      },
      "poi_business_url": "http://www.holyspiritgulfshores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374130617853753256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-spirit-episcopal-church",
      "poi_latitude": "30.2599544",
      "poi_longitude": "-87.7011326",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 251-968-5988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46e-775c-a983-0c63048ed3f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46e-775c-a983-0c63048ed3f5",
        "storage_key": "property/6737460151192640/019e1dde-f46e-775c-a983-0c63048ed3f5.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJofj0ejMbmogRqDfZEPB0mrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_d4bf5ce6-af5f-4f17-85e3-ad9a46bbcb86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Sherry's Kids Klub",
      "poi_type": "Education",
      "poi_address": "2408 W 2nd St, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11497213018354883345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sherrys-kids-klub",
      "poi_latitude": "30.2776309",
      "poi_longitude": "-87.6914686",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-1233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTaDs5ikFmogRERsKSlNOjp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c568e875-9264-4e14-9f7f-13179d160d51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Church at the Shores",
      "poi_type": "Education",
      "poi_address": "541 Cotton Creek Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c0ab-7327-a534-b0ca12a7a366.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c0ab-7327-a534-b0ca12a7a366",
        "storage_key": "property/6737460151192640/019e1dde-c0ab-7327-a534-b0ca12a7a366.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.churchattheshores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9901619191589762530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "church-at-the-shores",
      "poi_latitude": "30.2967453",
      "poi_longitude": "-87.6679077",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-202-9608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46e-775c-a983-0c63048ed3f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46e-775c-a983-0c63048ed3f5",
        "storage_key": "property/6737460151192640/019e1dde-f46e-775c-a983-0c63048ed3f5.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRYHscwPmogR4vXllzGeaYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_8dba293b-ec9e-4ed3-894f-3a163063ab78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Waterville USA/Escape House",
      "poi_type": "Entertainment",
      "poi_address": "906 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Amusement park with attractions including mini-golf, laser tag, go-karts & seasonal water rides.",
      "poi_long_description": "Amusement park with attractions including mini-golf, laser tag, go-karts & seasonal water rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-bebe-776a-a769-7c0fb2480b44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-bebe-776a-a769-7c0fb2480b44",
        "storage_key": "property/6737460151192640/019e1ddc-bebe-776a-a769-7c0fb2480b44.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://watervilleusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5972101509895414626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterville-usaescape-house",
      "poi_latitude": "30.2583306",
      "poi_longitude": "-87.6870639",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-948-2106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ao5J8YEmogRYuPjg64q4VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_f16eecff-90db-4733-bb09-ac8083dc5896",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Hangout",
      "poi_type": "Entertainment",
      "poi_address": "101 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Colorful beach pick known for its oyster cook-off, live music & party vibe in an open-air space.",
      "poi_long_description": "Colorful beach pick known for its oyster cook-off, live music & party vibe in an open-air space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-badf-71d0-a8b2-9efdced97ab7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-badf-71d0-a8b2-9efdced97ab7",
        "storage_key": "property/6737460151192640/019e1ddc-badf-71d0-a8b2-9efdced97ab7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thehangout.com/hangout-gulf-shores/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643066140364217520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hangout",
      "poi_latitude": "30.2481175",
      "poi_longitude": "-87.68921519999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-948-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3e61-718a-86cd-ac1c3c3006db",
        "storage_key": "property/6737460151192640/019e1ddd-3e61-718a-86cd-ac1c3c3006db.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSU2qLbcEmogRsJwBQpAN04U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_1723fa0a-bf3a-4214-bc28-b802d6edb675",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Track - Gulf Shores",
      "poi_type": "Entertainment",
      "poi_address": "3200 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Outdoor amusement park with go-kart tracks & bumper boats, plus roller coasters & arcade games.",
      "poi_long_description": "Outdoor amusement park with go-kart tracks & bumper boats, plus roller coasters & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-e4f6-757e-ac3d-37cd95582cc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-e4f6-757e-ac3d-37cd95582cc0",
        "storage_key": "property/6737460151192640/019e1ddc-e4f6-757e-ac3d-37cd95582cc0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.funatthetrack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=510154717045743835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-track---gulf-shores",
      "poi_latitude": "30.2864132",
      "poi_longitude": "-87.68571519999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-270-0209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQO2vSUFmogR22AAIgNvFAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_bd539161-e48f-4f74-aed1-0806bf50cef5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Alabama Gulf Coast Zoo",
      "poi_type": "Entertainment",
      "poi_address": "20499 Oak Rd E, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Home to more than 500 animals, this zoo offers hands-on experiences with kangaroos & other critters.",
      "poi_long_description": "Home to more than 500 animals, this zoo offers hands-on experiences with kangaroos & other critters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-c576-77fc-96a3-f7b4573d024a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-c576-77fc-96a3-f7b4573d024a",
        "storage_key": "property/6737460151192640/019e1ddc-c576-77fc-96a3-f7b4573d024a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://alabamagulfcoastzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9777256349209079055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alabama-gulf-coast-zoo",
      "poi_latitude": "30.3157177",
      "poi_longitude": "-87.6762971",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 251-256-7008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_yEkM8EmogRDy2K9NjKr4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_10836489-e6a1-4841-a19e-649dafcde328",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Pelican Place at Craft Farms",
      "poi_type": "Entertainment",
      "poi_address": "3800 Gulf Shores Pkwy Suite 402, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-b90a-7410-896a-ec503a3ad325.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-b90a-7410-896a-ec503a3ad325",
        "storage_key": "property/6737460151192640/019e1dde-b90a-7410-896a-ec503a3ad325.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16061361413032589171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pelican-place-at-craft-farms",
      "poi_latitude": "30.3018043",
      "poi_longitude": "-87.68098069999999",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-968-3638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4zmL3UEFmogRczf5wBtr5d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e6c7ec39-fc6b-4f61-b6eb-c15d915321fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf State Park Pier",
      "poi_type": "Entertainment",
      "poi_address": "20800 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "This long, wide pier with scenic beach & ocean views is a popular place for fishing.",
      "poi_long_description": "This long, wide pier with scenic beach & ocean views is a popular place for fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c381-72ba-bf98-795b0ac76c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c381-72ba-bf98-795b0ac76c90",
        "storage_key": "property/6737460151192640/019e1dde-c381-72ba-bf98-795b0ac76c90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alapark.com/parks/gulf-state-park/fishing-and-education-pier",
      "poi_directions_map_url": "https://maps.google.com/?cid=3621263665367688359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-state-park-pier",
      "poi_latitude": "30.2497985",
      "poi_longitude": "-87.66771469999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-967-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNea8h40EmogRpyRFDB5QQTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fishing_pier"
    },
    {
      "id": "custom_356b757d-fa8c-41b5-ab2c-12010ca8a172",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Wharf Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "23101 Canal Rd, Orange Beach, AL 36561, USA",
      "poi_short_description": "Big-name concerts at the Wharf complex, which also features a marina, shopping & dining.",
      "poi_long_description": "Big-name concerts at the Wharf complex, which also features a marina, shopping & dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d0cc-776f-8dae-cc618758c9a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d0cc-776f-8dae-cc618758c9a4",
        "storage_key": "property/6737460151192640/019e1dde-d0cc-776f-8dae-cc618758c9a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://alwharf.com/amphitheater",
      "poi_directions_map_url": "https://maps.google.com/?cid=2850575699396831432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wharf-amphitheater",
      "poi_latitude": "30.2950643",
      "poi_longitude": "-87.6257693",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 251-224-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXObmrYHmogRyKjo335Hjyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_3971c4b5-98d6-447c-b5fd-6e7eff18f99c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Coastal Arts Center of Orange Beach",
      "poi_type": "Entertainment",
      "poi_address": "26389 Canal Rd, Orange Beach, AL 36561, USA",
      "poi_short_description": "Waterfront campus offering art classes in many mediums, demonstrations & a gallery with local works.",
      "poi_long_description": "Waterfront campus offering art classes in many mediums, demonstrations & a gallery with local works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c77b-70ea-ba7a-7786b1d7ece4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c77b-70ea-ba7a-7786b1d7ece4",
        "storage_key": "property/6737460151192640/019e1dde-c77b-70ea-ba7a-7786b1d7ece4.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://www.orangebeachal.gov/ArtCenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=1858328652716063794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coastal-arts-center-of-orange-beach",
      "poi_latitude": "30.2935087",
      "poi_longitude": "-87.57585399999999",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 251-981-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTOo9rMHmogRMjwSVRAcyhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_0a06ea0d-eb07-424a-969c-bcaab743e4c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Fort Morgan State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "110 AL-180, Gulf Shores, AL 36542, USA",
      "poi_short_description": "19th century military fort offering tours & displays related to Civil War history & beyond.",
      "poi_long_description": "19th century military fort offering tours & displays related to Civil War history & beyond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-cbb0-75ba-9baa-301ecf2b8088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-cbb0-75ba-9baa-301ecf2b8088",
        "storage_key": "property/6737460151192640/019e1dde-cbb0-75ba-9baa-301ecf2b8088.webp",
        "width": 1280,
        "height": 791
      },
      "poi_business_url": "https://ahc.alabama.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15153556996977539779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-morgan-state-historic-site",
      "poi_latitude": "30.23115679999999",
      "poi_longitude": "-88.0191909",
      "poi_miles_from_property": "20.2",
      "poi_walking_minutes": "7 hours 17 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 251-540-7127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodlbd68omogRwzp7QM0_TNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_31db1a09-9566-4ecf-9ea3-3605bb91ae22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Tropic Falls at OWA",
      "poi_type": "Entertainment",
      "poi_address": "1501 S Owa Blvd, Foley, AL 36535, USA",
      "poi_short_description": "Playful theme park with 22 rides from roller coasters to spinning tea cups, plus games & shows.",
      "poi_long_description": "Playful theme park with 22 rides from roller coasters to spinning tea cups, plus games & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-ca37-71c8-8a63-f85f74e3bc30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-ca37-71c8-8a63-f85f74e3bc30",
        "storage_key": "property/6737460151192640/019e1dde-ca37-71c8-8a63-f85f74e3bc30.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://visitowa.com/destinations/tropic-falls-at-owa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12545438543766947597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropic-falls-at-owa",
      "poi_latitude": "30.3737323",
      "poi_longitude": "-87.6580479",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 251-923-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QRAIP8OmogRDQe5EONZGq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_be7e27e0-dee5-4b3b-b3d0-c09b813934ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Baldwin Health - Freestanding Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "3590 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-ca46-730d-8465-387b22c6d2fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-ca46-730d-8465-387b22c6d2fe",
        "storage_key": "property/6737460151192640/019e1dde-ca46-730d-8465-387b22c6d2fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baldwinhealth.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16210426300646099167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-health---freestanding-emergency-department",
      "poi_latitude": "30.2930767",
      "poi_longitude": "-87.6823025",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 251-215-4853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_LdqAwFmogR3wipe9UA9-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_6b26a3cc-da01-449f-97b9-d396fe8f4dd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Baldwin Health",
      "poi_type": "Health and Wellness",
      "poi_address": "1613 N McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-c8c8-7607-89f9-bda2419dce84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-c8c8-7607-89f9-bda2419dce84",
        "storage_key": "property/6737460151192640/019e1dde-c8c8-7607-89f9-bda2419dce84.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.baldwinhealth.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=7408245077329768860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-health",
      "poi_latitude": "30.4260622",
      "poi_longitude": "-87.6843473",
      "poi_miles_from_property": "17",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 251-949-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3dc0-73b8-8fb7-53dbdf8fc3e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3dc0-73b8-8fb7-53dbdf8fc3e0",
        "storage_key": "property/6737460151192640/019e1ddd-3dc0-73b8-8fb7-53dbdf8fc3e0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5HSkeUNmogRnPFGs6Vfz2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9f8f23cc-04bc-4fdf-9d9b-3c6509405c25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Baldwin Health Primary and Urgent Care - Gulf Shores",
      "poi_type": "Health and Wellness",
      "poi_address": "101 E 15th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-cda9-70a8-b1d2-197e4a7efbb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-cda9-70a8-b1d2-197e4a7efbb6",
        "storage_key": "property/6737460151192640/019e1dde-cda9-70a8-b1d2-197e4a7efbb6.webp",
        "width": 960,
        "height": 635
      },
      "poi_business_url": "https://baldwin-health-medical-group-chs.inquicker.com/providers/27087?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8209875027538663628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-health-primary-and-urgent-care---gulf-shores",
      "poi_latitude": "30.2677688",
      "poi_longitude": "-87.68794899999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-962-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9bsYtAEmogRzNjK-tZV73E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2cd42445-fd79-44c9-8413-902f5bfdc785",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Family Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "251 Clubhouse Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d3df-764d-aa55-5a830158a454.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d3df-764d-aa55-5a830158a454",
        "storage_key": "property/6737460151192640/019e1dde-d3df-764d-aa55-5a830158a454.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://gulfshoresrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14519771140867744592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-family-pharmacy",
      "poi_latitude": "30.2706519",
      "poi_longitude": "-87.69106579999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-968-3784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f455-74b8-9d72-acbef5250421.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f455-74b8-9d72-acbef5250421",
        "storage_key": "property/6737460151192640/019e1dde-f455-74b8-9d72-acbef5250421.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJufcGOtEEmogRUONjb-yWgMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_82ce5c75-9a7c-4f16-856c-f53d77048577",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Fitness Factory",
      "poi_type": "Health and Wellness",
      "poi_address": "3501 Gulf Shores Pkwy STE 9, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Gym with 24/7 access offering a variety of equipment, day or week passes, and a welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-cd26-767f-b25a-56677d8a6163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-cd26-767f-b25a-56677d8a6163",
        "storage_key": "property/6737460151192640/019e1ddc-cd26-767f-b25a-56677d8a6163.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://fitnessfactorynow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=189161923044219216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-factory",
      "poi_latitude": "30.292598",
      "poi_longitude": "-87.684975",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 251-426-5247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUIF01gFmogRUJkUTMQJoAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_515f2e44-632d-4c11-ab7f-1da891a1d400",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Glow Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "314 E 21st Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Warm, clean, bright yoga studio featuring a range of classes, from beginner style to power yoga.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d1fd-77f8-b697-f12fc1784dc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d1fd-77f8-b697-f12fc1784dc5",
        "storage_key": "property/6737460151192640/019e1dde-d1fd-77f8-b697-f12fc1784dc5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://glowstudioandshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7319476258034769397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glow-yoga",
      "poi_latitude": "30.274787",
      "poi_longitude": "-87.68220819999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTQvbsgEmogR9V0RXuAAlGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_0d8be602-d4d1-4f54-a69c-26b33e178dc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "HOTWORX - Gulf Shores AL",
      "poi_type": "Health and Wellness",
      "poi_address": "160 Cotton Creek Dr Suite 275, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d203-772b-bd87-dd4989a4c132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d203-772b-bd87-dd4989a4c132",
        "storage_key": "property/6737460151192640/019e1dde-d203-772b-bd87-dd4989a4c132.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/gulfshores?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4919126022699426191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---gulf-shores-al",
      "poi_latitude": "30.2980688",
      "poi_longitude": "-87.6813829",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-332-2042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEyEb2LkFmogRjyFhFA4_REQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_41f262ef-4552-4969-8cc4-448d1ef28618",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20115 State Park Road, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Serene park with beaches, trails & pier fishing plus tennis, golf & a zip line above the dunes.",
      "poi_long_description": "Serene park with beaches, trails & pier fishing plus tennis, golf & a zip line above the dunes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d515-755c-83c0-8357b59bcfe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d515-755c-83c0-8357b59bcfe5",
        "storage_key": "property/6737460151192640/019e1dde-d515-755c-83c0-8357b59bcfe5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.alapark.com/parks/gulf-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046674664807600187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-state-park",
      "poi_latitude": "30.2684061",
      "poi_longitude": "-87.63421149999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 251-948-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAf8qlDAEmogROxDShN5jCUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_4af11d8b-6e0e-4298-8c33-b76933e5dba0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Wade Ward Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Gulf Shores Pkwy, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Charming, 12-acre park in a lush coastal setting featuring a variety of native wildlife & wetlands.",
      "poi_long_description": "Charming, 12-acre park in a lush coastal setting featuring a variety of native wildlife & wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-db63-737d-b660-d1a58143275b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-db63-737d-b660-d1a58143275b",
        "storage_key": "property/6737460151192640/019e1dde-db63-737d-b660-d1a58143275b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1222/Wade-Ward-Nature-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13542842929683103843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wade-ward-nature-park",
      "poi_latitude": "30.2520127",
      "poi_longitude": "-87.68904289999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZkQvbcEmogRYwCsOOTX8bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1ed5e697-3350-412c-8c40-aebf4677e624",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Meyer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 E 22nd Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "This 12-acre public recreation place has a basketball court, shaded picnic tables & play sets.",
      "poi_long_description": "This 12-acre public recreation place has a basketball court, shaded picnic tables & play sets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d8a9-75c8-908b-6f7c48047b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d8a9-75c8-908b-6f7c48047b66",
        "storage_key": "property/6737460151192640/019e1dde-d8a9-75c8-908b-6f7c48047b66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1173/Meyer-Park-Pavilion",
      "poi_directions_map_url": "https://maps.google.com/?cid=12675971864696342763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meyer-park",
      "poi_latitude": "30.2767764",
      "poi_longitude": "-87.68030859999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 251-968-1173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_J_f98EmogR60gSMkAZ6q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_66d572b9-99d5-4791-818f-1e9421251dea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Johnnie Sims Park Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2008 W 3rd St, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Spacious picnic & event pavilion rented for parties, performances & more, in a park with a beach.",
      "poi_long_description": "Spacious picnic & event pavilion rented for parties, performances & more, in a park with a beach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d71d-731f-9595-b3746602691c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d71d-731f-9595-b3746602691c",
        "storage_key": "property/6737460151192640/019e1dde-d71d-731f-9595-b3746602691c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1172/Johnnie-Sims-Park-Pavilion",
      "poi_directions_map_url": "https://maps.google.com/?cid=8808401359133106996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnnie-sims-park-pavilion",
      "poi_latitude": "30.2739458",
      "poi_longitude": "-87.6944152",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-2425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQwjdQEmogRNGMyAl66PXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7c035727-f86c-4922-b745-71f43a847d66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Canal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d70c-75cf-82c5-6c4ae71f7a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d70c-75cf-82c5-6c4ae71f7a36",
        "storage_key": "property/6737460151192640/019e1dde-d70c-75cf-82c5-6c4ae71f7a36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1216/Canal-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9492662494795148701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canal-park",
      "poi_latitude": "30.2781754",
      "poi_longitude": "-87.6865535",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbW_6an4FmogRnS3wpj62vIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_05185be7-eeb1-460b-a77d-25c7767fd879",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Mo's Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18068 Fort Morgan Road, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Easygoing park for boating, kayaking and fishing, plus picnic tables and swings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-d955-7159-83af-c2c17d66d8e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-d955-7159-83af-c2c17d66d8e4",
        "storage_key": "property/6737460151192640/019e1dde-d955-7159-83af-c2c17d66d8e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1221/Mos-Landing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4189693610568699978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mos-landing-park",
      "poi_latitude": "30.25568",
      "poi_longitude": "-87.71561430000001",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-2425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUyTjT8bmogRStCrDyTIJDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f8896232-3ec8-4f55-adfb-866607d34d4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "308 Clubhouse Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Relaxed park featuring separate zones for large and small pups, along with water fountains.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-dc79-7619-9af5-30f526e4b41d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-dc79-7619-9af5-30f526e4b41d",
        "storage_key": "property/6737460151192640/019e1dde-dc79-7619-9af5-30f526e4b41d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gulfshores.com/things-to-do/gulf-shores-dog-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8115572225663630000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-dog-park",
      "poi_latitude": "30.2710484",
      "poi_longitude": "-87.69176619999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_W1-9MEmogRsPq06_BNoHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_0150d700-8f4f-472b-b59a-5bc30e7b5dee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "City Of Gulf Shores Wetlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19025 Oak Rd W, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Scenic park with walking trails, a fishing pier, benches & gazebos in a wetlands setting.",
      "poi_long_description": "Scenic park with walking trails, a fishing pier, benches & gazebos in a wetlands setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e4a5-7284-9ff9-df1da7e3a172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e4a5-7284-9ff9-df1da7e3a172",
        "storage_key": "property/6737460151192640/019e1dde-e4a5-7284-9ff9-df1da7e3a172.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gulfshoresal.gov/1224/Wetlands-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5583880557021656977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-gulf-shores-wetlands-park",
      "poi_latitude": "30.3179746",
      "poi_longitude": "-87.6967415",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-968-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXzQmpFQFmogRkXd8LcjtfU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d82963a0-f39b-47fc-9c51-c0d5ceca2569",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Bon Secour National Wildlife Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12295 AL-180, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Beach refuge known for sea turtles, migratory birds & other wildlife offers trails & events.",
      "poi_long_description": "Beach refuge known for sea turtles, migratory birds & other wildlife offers trails & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-de72-76e8-b0c5-064b3a20caab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-de72-76e8-b0c5-064b3a20caab",
        "storage_key": "property/6737460151192640/019e1dde-de72-76e8-b0c5-064b3a20caab.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.fws.gov/refuge/Bon_Secour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15450969870097076017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secour-national-wildlife-refuge",
      "poi_latitude": "30.2408927",
      "poi_longitude": "-87.8245353",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 251-540-7720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45",
        "storage_key": "property/6737460151192640/019e1ddd-3db3-76ef-91c5-ae5d0ac6ee45.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9Gix9EYmogRMU9m7jvfbNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_ad02d9a4-60d1-443f-98cf-3d9faa61975f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Mobile Bay Ferry - Fort Morgan Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "110 AL-180, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-dda4-74de-ae42-f6e7f0836193.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-dda4-74de-ae42-f6e7f0836193",
        "storage_key": "property/6737460151192640/019e1dde-dda4-74de-ae42-f6e7f0836193.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mobilebayferry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=506759196429650213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mobile-bay-ferry---fort-morgan-landing",
      "poi_latitude": "30.2314861",
      "poi_longitude": "-88.01461049999999",
      "poi_miles_from_property": "19.9",
      "poi_walking_minutes": "7 hours 11 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 251-861-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb-ToxKsomogRJQna4c1eCAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "custom_8bdd1c3f-1378-4b10-ab2c-1ffdd7eecb50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores International Airport at Jack Edwards Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "1155 Commerce Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-1a37-75a5-9b69-2f479c3b0792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddd-1a37-75a5-9b69-2f479c3b0792",
        "storage_key": "property/6737460151192640/019e1ddd-1a37-75a5-9b69-2f479c3b0792.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://flyjka.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13430190755623891884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-international-airport-at-jack-edwards-field",
      "poi_latitude": "30.287539",
      "poi_longitude": "-87.672506",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 251-967-3968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3ec5-735e-890a-09a11432e3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3ec5-735e-890a-09a11432e3f1",
        "storage_key": "property/6737460151192640/019e1ddd-3ec5-735e-890a-09a11432e3f1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ0ldRAFmogRrHOyBlafYbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7caf860f-4a84-4e32-b1e9-460029401cdd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Pensacola International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2430 Airport Blvd, Pensacola, FL 32504, USA",
      "poi_short_description": "Regional airport serving the Southeast & featuring free WiFi & a variety of car rental options.",
      "poi_long_description": "Regional airport serving the Southeast & featuring free WiFi & a variety of car rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e0d3-7761-8b1d-247f75a45041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e0d3-7761-8b1d-247f75a45041",
        "storage_key": "property/6737460151192640/019e1dde-e0d3-7761-8b1d-247f75a45041.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.flypensacola.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11310433213529869624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pensacola-international-airport",
      "poi_latitude": "30.4737579",
      "poi_longitude": "-87.1861041",
      "poi_miles_from_property": "41.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 29 mins",
      "poi_driving_minutes": "1 hour 8 mins",
      "poi_business_phone": "+1 850-436-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3ec5-735e-890a-09a11432e3f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3ec5-735e-890a-09a11432e3f1",
        "storage_key": "property/6737460151192640/019e1ddd-3ec5-735e-890a-09a11432e3f1.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJrc7cbDjAkIgROE06HBW79pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_4bc9870a-1275-4612-be20-1721d7ae238b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Baldwin County Brats",
      "poi_type": "Transportation & Transit",
      "poi_address": "18100 County Rd 54, Robertsdale, AL 36567, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://baldwincountyal.gov/departments/BRATS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5459384170998902012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwin-county-brats",
      "poi_latitude": "30.56696269999999",
      "poi_longitude": "-87.7150881",
      "poi_miles_from_property": "28.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 251-990-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46d-71c0-bf96-ad2aa9bd3597",
        "storage_key": "property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwErYLttmogR_KzHfPqgw0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_407527f2-6efa-47eb-b14b-6d8ccfe1772b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Parkway Equipment Inc",
      "poi_type": "Transportation & Transit",
      "poi_address": "25091 AL-59, Loxley, AL 36551, USA",
      "poi_short_description": "Friendly place offering lawn and garden equipment like tractors and mowers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e423-7666-8038-eee3f9e7596b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e423-7666-8038-eee3f9e7596b",
        "storage_key": "property/6737460151192640/019e1dde-e423-7666-8038-eee3f9e7596b.webp",
        "width": 1280,
        "height": 1113
      },
      "poi_business_url": "http://www.parkwayequipment.com/?utm_source=local&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1990303834795958363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkway-equipment-inc",
      "poi_latitude": "30.5905676",
      "poi_longitude": "-87.73120399999999",
      "poi_miles_from_property": "30.6",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "2 hours 33 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 251-964-6733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU3pF9dNtmogRW2Ac7Mr6nhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_cda85c15-f012-4a01-92f5-ab8c6cd58a35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Tanger Outlets Foley",
      "poi_type": "Transportation & Transit",
      "poi_address": "2601 S McKenzie St, Foley, AL 36535, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e709-75a3-afcc-842783e5a77e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e709-75a3-afcc-842783e5a77e",
        "storage_key": "property/6737460151192640/019e1dde-e709-75a3-afcc-842783e5a77e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tangeroutlet.com/foley",
      "poi_directions_map_url": "https://maps.google.com/?cid=4092886600814833726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanger-outlets-foley",
      "poi_latitude": "30.3763263",
      "poi_longitude": "-87.68018719999999",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 251-943-9303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f4aa-769d-82bc-2ea6807d5427",
        "storage_key": "property/6737460151192640/019e1dde-f4aa-769d-82bc-2ea6807d5427.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuxOaTTEOmogRPjCGq63azDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b9b46d46-8e05-4b38-879a-d43890991497",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Wharf",
      "poi_type": "Transportation & Transit",
      "poi_address": "23101 Canal Rd, Orange Beach, AL 36561, USA",
      "poi_short_description": "Waterfront area with shops, a marina & restaurants, as well as rides & an amphitheater.",
      "poi_long_description": "Waterfront area with shops, a marina & restaurants, as well as rides & an amphitheater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e70a-738c-a0fd-dcd6d5449e7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e70a-738c-a0fd-dcd6d5449e7b",
        "storage_key": "property/6737460151192640/019e1dde-e70a-738c-a0fd-dcd6d5449e7b.webp",
        "width": 1280,
        "height": 1128
      },
      "poi_business_url": "https://alwharf.com/?utm_source=GBP&utm_medium=organic&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3508481623956263118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wharf",
      "poi_latitude": "30.2930829",
      "poi_longitude": "-87.62887529999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 251-224-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfvStq0FmogRzhDmwHKhsDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_1cbb19da-ce01-4785-82f0-3184785498aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1905 W 1st St, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-eb4b-74cd-b505-15e077549513.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-eb4b-74cd-b505-15e077549513",
        "storage_key": "property/6737460151192640/019e1dde-eb4b-74cd-b505-15e077549513.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gulfshoresal.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17163014624390572511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-city-hall",
      "poi_latitude": "30.2713921",
      "poi_longitude": "-87.68927939999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-968-2425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46d-71c0-bf96-ad2aa9bd3597",
        "storage_key": "property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYAjQNcEmogR32miCd5GL-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ff2eeb9b-75bb-4f7a-9fae-8303b398f737",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 Clubhouse Dr, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5446908115252391338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-police-department",
      "poi_latitude": "30.2712612",
      "poi_longitude": "-87.68976409999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 251-968-2431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46d-71c0-bf96-ad2aa9bd3597",
        "storage_key": "property/6737460151192640/019e1dde-f46d-71c0-bf96-ad2aa9bd3597.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfhUnNQEmogRqq3PZRJOl0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_df372575-b896-4625-aee9-030193d7949d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores Fire Rescue",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1921 W 1st St, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e77f-7333-b7e4-9087fd2e2d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e77f-7333-b7e4-9087fd2e2d7b",
        "storage_key": "property/6737460151192640/019e1dde-e77f-7333-b7e4-9087fd2e2d7b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gulfshoresal.gov/Index.aspx?NID=327",
      "poi_directions_map_url": "https://maps.google.com/?cid=7996102242779339151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-fire-rescue",
      "poi_latitude": "30.2720314",
      "poi_longitude": "-87.6892949",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-7422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6",
        "storage_key": "property/6737460151192640/019e1ddd-3fac-76d5-b8f9-eb3a7fedbae6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYAjQNcEmogRjxmR6J_c924",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_0f575cb9-f454-4476-99d8-0f19554bd649",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "Gulf Shores City Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 E 16th Ave, Gulf Shores, AL 36542, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e904-70bc-b9ff-b6544fce77c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e904-70bc-b9ff-b6544fce77c5",
        "storage_key": "property/6737460151192640/019e1dde-e904-70bc-b9ff-b6544fce77c5.webp",
        "width": 983,
        "height": 1280
      },
      "poi_business_url": "https://www.gsboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1497727121371624276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-shores-city-schools",
      "poi_latitude": "30.26965299999999",
      "poi_longitude": "-87.6826399",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 251-968-9873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-412f-70eb-9433-6bcffe037a20",
        "storage_key": "property/6737460151192640/019e1ddd-412f-70eb-9433-6bcffe037a20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVUBddwEmogRVPPSr-H-yBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31cb6acd-48a9-4798-9018-ec2f040a394b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "poi_name": "The Lodge at Gulf State Park, a Hilton Hotel",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21196 E Beach Blvd, Gulf Shores, AL 36542, USA",
      "poi_short_description": "Relaxed hotel inside a state park, plus 2 beachfront restaurants, 2 bars & an outdoor pool.",
      "poi_long_description": "Relaxed hotel inside a state park, plus 2 beachfront restaurants, 2 bars & an outdoor pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-e8a7-76d8-94e4-619d45a8c8da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dde-e8a7-76d8-94e4-619d45a8c8da",
        "storage_key": "property/6737460151192640/019e1dde-e8a7-76d8-94e4-619d45a8c8da.webp",
        "width": 1023,
        "height": 682
      },
      "poi_business_url": "https://www.hilton.com/en/hotels/pnslghh-the-lodge-at-gulf-state-park/?SEO_id=GMB-AMER-HH-PNSLGHH&y_source=1_MTExMDY0OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6482125312822728446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-lodge-at-gulf-state-park-a-hilton-hotel",
      "poi_latitude": "30.2501867",
      "poi_longitude": "-87.66401549999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 251-540-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1dde-f46f-74bc-833d-cacff2883827.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dde-f46f-74bc-833d-cacff2883827",
        "storage_key": "property/6737460151192640/019e1dde-f46f-74bc-833d-cacff2883827.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJdajX5QMFmogR_tZd1KAi9Vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    }
  ],
  "office_hours": [
    {
      "id": "custom_10c4020c-a107-4d87-b98c-64800f131425",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_bcd73bff-2e00-44cd-993d-8a183944c787",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d053d10e-72d5-46a0-8303-e58690ec4215",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_babf5a0e-75ba-4363-99d5-fad04426b2e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e1c76211-626a-4fc9-ad9e-6def327dd8a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_47533e89-e542-4930-be72-1c3cd5934078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_3aa95b4b-2e06-4163-af01-214a1f5e3652",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "rating": "5",
      "name": "Jerri Lindsey",
      "text": "Recently tour the property. Very impressed with Mandi and Andy the managers there. Look forward to leasing in the future. Will recommend!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_0420e517-20c5-4974-90f5-b0c2e5853bde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "rating": "5",
      "name": "Michelle Vaz",
      "text": "five stars! super friendly office staff and well maintained show units!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_cd43af03-6c41-4bd1-a58a-182acb8ba821",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "rating": "5",
      "name": "Gloria Mcconn",
      "text": "I love it here now that Mandi's here!! She is by far the best!! She gets things DONE!!!",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_1e502807-fc0c-45a0-afa4-26863bc95b52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "rating": "5",
      "name": "Woody Odom",
      "text": "The new management is great, we finally have someone who cares about the property and the tenants. Thanks Amanda for all your hard work!!!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_336a7752-ab60-42c5-b115-bbf7ab987465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "rating": "5",
      "name": "Wes D",
      "text": "Madi and Qairo were amazing at helping my mother in law find an apartment! She's not so great at things like this and they were super patient with her. The property and apartments was exactly as expected. Can't wait to visit her and enjoy the gorgeous pool and gym! There was a maintenance guy, I think his name is Andrew or Andy he was amazing! He was introduced to us up front so we know who to expect and call if there was an issue! 100% recommend",
      "date": "2026-03-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4f68ac08-4bd5-4841-9a75-664028c0c3aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019e1ddc-bbe9-70c9-a8d1-8b2fdadce0fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1ddc-bbe9-70c9-a8d1-8b2fdadce0fb",
        "storage_key": "property/6737460151192640/019e1ddc-bbe9-70c9-a8d1-8b2fdadce0fb.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=66aa8e05a6a878112d2d2300"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fe0-85ce-73ed-a44d-a915154af908",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-summer-trace-at-gulf-shores-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640"
    },
    {
      "lead_collector_id": "0199de84-f650-70da-9ae3-fa37264ccb25",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-summer-trace-at-gulf-shores-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640"
    },
    {
      "lead_collector_id": "019d6351-0f79-764f-9b2f-4cc052ae724a",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "apartments-with-pool-gulf-shores-al",
      "search_query": "apartments with pool in Gulf Shores AL",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Gulf Shores, AL",
      "h2_subtitle": "Discover your perfect apartment in Gulf Shores, AL, complete with a stunning pool. Dive into luxury living at Summer Trace.",
      "page_copy": "Looking for apartments with a pool in Gulf Shores, AL? Welcome to Summer Trace at Gulf Shores, where a refreshing dip in our sparkling pool is just the beginning. Our community offers a variety of one, two, and three-bedroom floor plans designed to cater to your lifestyle.\n\nIn addition to the pool, enjoy amenities such as a state-of-the-art fitness center and a relaxing spa. Whether you're hosting a barbecue at our grill area or relaxing in a wheelchair accessible room, Summer Trace is designed for comfort and convenience. Come see why Summer Trace stands out among apartments in Baldwin County!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Gulf Shores, AL",
      "seo_description": "Explore Summer Trace's Gulf Shores apartments with pool, spa, and fitness center. Find your dream home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-play-area-baldwin-county",
      "search_query": "pet friendly apartments with play area Baldwin County",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Baldwin County",
      "h2_subtitle": "Find pet friendly apartments in Baldwin County with an exciting play area. Discover the amenities at Summer Trace at Gulf Shores.",
      "page_copy": "Searching for pet friendly apartments with a play area in Baldwin County? Look no further than Summer Trace at Gulf Shores. Our community not only welcomes your furry friends but also offers a dedicated pet play area where they can frolic and enjoy.\n\nIt's not just a haven for pets; residents have access to a range of amenities such as a state-of-the-art fitness center, a sparkling pool, and relaxing spa. At Summer Trace, we ensure both you and your pets have access to the comforts and convenience that make life enjoyable. Visit us to find out how we prioritize a pet-friendly lifestyle!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments Baldwin County",
      "seo_description": "Discover pet friendly apartments with a play area in Baldwin County. Enjoy the perfect home at Summer Trace at Gulf Shores.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "modern-fitness-center-apartments-gulf-shores-36542",
      "search_query": "modern fitness center apartments Gulf Shores 36542",
      "category": "Amenity",
      "h1_title": "Modern Fitness Center Apartments in Gulf Shores",
      "h2_subtitle": "Explore apartments in Gulf Shores, 36542 with a modern fitness center. Experience the unique lifestyle at Summer Trace.",
      "page_copy": "For those in Gulf Shores, 36542 seeking apartments with a modern fitness center, Summer Trace is your ideal choice. Our state-of-the-art gym ensures you maintain your fitness routine just steps from home. \n\nChoose from a variety of floor plans, including one, two, and three-bedroom options, all designed with comfort in mind. Beyond the fitness center, residents can enjoy a sparkling pool and a relaxing spa, making it easy to unwind after a workout. Embrace the holistic lifestyle offered at Summer Trace at Gulf Shores today, where convenience meets modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Fitness Center Apartments, Gulf Shores",
      "seo_description": "Find your dream apartment with a modern fitness center in Gulf Shores, 36542 at Summer Trace. Enjoy wellness at home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-baldwin-county",
      "search_query": "air conditioned apartments near Baldwin County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Baldwin County",
      "h2_subtitle": "Discover the comfort of air conditioned apartments conveniently located near Baldwin County. Experience the luxury of Summer Trace.",
      "page_copy": "Searching for air conditioned apartments near Baldwin County? Summer Trace at Gulf Shores offers the perfect climate-controlled retreat for those hot Alabama days. Our thoughtfully designed homes ensure comfort with modern heating and air conditioning systems.\n\nEnjoy a wide array of amenities, including a refreshing swimming pool, state-of-the-art fitness center, and pet play area. Whether it's a hot summer afternoon or a brisk winter day, Summer Trace provides the perfect environment to relax in comfort. Discover the ease and convenience of living at Summer Trace today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Baldwin County",
      "seo_description": "Stay cool in air conditioned apartments near Baldwin County. Discover amenities at Summer Trace in Gulf Shores.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "luxury-apartments-walk-in-closets-gulf-shores",
      "search_query": "luxury apartments with walk-in closets in Gulf Shores",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Walk-In Closets",
      "h2_subtitle": "Experience luxury living in Gulf Shores with spacious walk-in closets. Discover your perfect home at Summer Trace today.",
      "page_copy": "If you're in search of luxury apartments with walk-in closets in Gulf Shores, Summer Trace at Gulf Shores is the answer. Our upscale apartments feature expansive storage options, allowing you to organize with ease and style.\n\nBeyond our beautifully designed living spaces, indulge in an array of amenities such as a sparkling pool, state-of-the-art fitness center, and a dedicated pet play area. Elevate your lifestyle and enjoy the sophistication of walk-in closets that complement the overall luxury and convenience found at Summer Trace.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Walk-In Closets, Gulf Shores",
      "seo_description": "Explore luxury living at Summer Trace in Gulf Shores with spacious walk-in closets. Unmatched elegance and convenience await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-gulf-shores-al",
      "search_query": "two bedroom apartments Gulf Shores AL",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Gulf Shores, AL",
      "h2_subtitle": "Discover spacious two bedroom apartments in Gulf Shores, AL. Enjoy modern living at Summer Trace with top-notch amenities.",
      "page_copy": "Looking for two bedroom apartments in Gulf Shores, AL? Summer Trace offers spacious and beautifully designed two-bedroom floor plans that cater to your lifestyle needs. Perfect for small families, roommates, or individuals looking for extra space, our apartments provide the comfort and convenience you seek.\n\nEach apartment is thoughtfully equipped with modern kitchens, air conditioning, and heating to ensure a comfortable living environment all year round. Complement your living experience with access to amenities like our sparkling pool, advanced fitness center, and pet play area. Schedule a tour today to see why Summer Trace is the ideal choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments, Gulf Shores, AL",
      "seo_description": "Find spacious two bedroom apartments in Gulf Shores, AL at Summer Trace. Enjoy modern amenities and a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-baldwin-county",
      "search_query": "one bedroom apartments Baldwin County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Baldwin County",
      "h2_subtitle": "Explore cozy one bedroom apartments in Baldwin County. Summer Trace offers comfort and convenience in Gulf Shores.",
      "page_copy": "Searching for one bedroom apartments in Baldwin County? Look no further than Summer Trace at Gulf Shores, where we offer thoughtfully designed one-bedroom layouts perfect for singles or couples. Our apartments provide an ideal balance of comfort and functionality, tailored to meet your needs.\n\nEnjoy amenities like a modern kitchen, air conditioning, and access to a sparkling pool and fitness center, ensuring a lifestyle filled with convenience and leisure. Situated in a vibrant neighborhood, Summer Trace is your go-to destination for relaxed and stylish living in Baldwin County. Schedule a visit today to see how we blend comfort and style at Summer Trace.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Baldwin County",
      "seo_description": "Discover comfortable one bedroom apartments in Baldwin County at Summer Trace. Enjoy modern amenities in Gulf Shores.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192640",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-36542",
      "search_query": "three bedroom apartments near 36542",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 36542",
      "h2_subtitle": "Find spacious three bedroom apartments near the 36542 area. Summer Trace offers ample living space and premium amenities.",
      "page_copy": "For those seeking three bedroom apartments near the 36542 area, Summer Trace at Gulf Shores provides exceptional living options. Our expansive three-bedroom floor plans are designed with families and roommates in mind, offering plentiful space and comfort.\n\nResidents enjoy well-appointed kitchens, efficient heating, and access to top-tier amenities like a shimmering pool and cutting-edge fitness center. Nestled in a vibrant community, Summer Trace ensures you experience the best of Gulf Shores living with all the convenience and leisure you desire. Visit us today and explore what makes our three-bedroom apartments a premier choice in the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a light gray apartment building with a parking lot in the foreground and trees with fall foliage.",
        "public_id": "019d0784-9ceb-7785-ad3a-b8393e3f955a",
        "storage_key": "property/6737460151192640/019d0784-9ceb-7785-ad3a-b8393e3f955a.webp",
        "width": 1240,
        "height": 710
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 36542",
      "seo_description": "Discover spacious three bedroom apartments near 36542 at Summer Trace. Enjoy premium amenities and comfort in Gulf Shores.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3408"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483512"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973406"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-56DCTWQ4"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "251-309-7417"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "251-309-7494"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "251-309-7344"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "251-714-7224"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "251-309-7334"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "251-309-7520"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "251-309-7493"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "251-309-7163"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "251-309-7205"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "251-351-0226"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "251-265-9050"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "251-309-7351"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "251-766-1250"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "251-360-3797"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "251-261-2189"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "251-714-7284"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "251-572-1331"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321233737"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "251-714-1801"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "251-357-1632"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f52be841ae711eef"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "251-360-3135"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "251-351-3744"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "251-309-7242"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "251-309-7510"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "251-274-8630"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "251-309-7458"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "251-309-7519"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "251-714-1805"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.summertraceatgulfshores.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192640/019e84b9-e6b1-735e-aaf0-bac9beca0ac3.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "251-309-7514"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "251-351-0226"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3408",
  "custom_repli_id": "5028483512",
  "custom_realpage_id": "4973406",
  "custom_knock_a_link": "https://www.summertraceatgulfshores.com?utm_knock=a",
  "custom_knock_g_link": "https://www.summertraceatgulfshores.com?utm_knock=g",
  "custom_knock_r_link": "https://www.summertraceatgulfshores.com?utm_knock=r",
  "custom_knock_w_link": "https://www.summertraceatgulfshores.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-56DCTWQ4",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.summertraceatgulfshores.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.summertraceatgulfshores.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.summertraceatgulfshores.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.summertraceatgulfshores.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.summertraceatgulfshores.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.summertraceatgulfshores.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "251-309-7417",
  "custom_knock_ads_link": "https://www.summertraceatgulfshores.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.summertraceatgulfshores.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "251-309-7494",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.summertraceatgulfshores.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.summertraceatgulfshores.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.summertraceatgulfshores.com?utm_knock=ppn",
  "custom_knock_r_number": "251-309-7344",
  "custom_knock_w_number": "251-714-7224",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "251-309-7334",
  "custom_knock_amap_link": "https://www.summertraceatgulfshores.com?utm_knock=amap",
  "custom_knock_ar_number": "251-309-7520",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "251-309-7493",
  "custom_knock_fb_number": "251-309-7163",
  "custom_knock_fl_number": "251-309-7205",
  "custom_knock_gp_number": "251-351-0226",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.summertraceatgulfshores.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "251-265-9050",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.summertraceatgulfshores.com?utm_knock=bcard",
  "custom_knock_bnr_number": "251-309-7351",
  "custom_knock_cfres_link": "https://www.summertraceatgulfshores.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "251-766-1250",
  "custom_knock_lgp_number": "251-360-3797",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.summertraceatgulfshores.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "251-261-2189",
  "custom_knock_psocl_link": "https://www.summertraceatgulfshores.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "251-714-7284",
  "custom_knock_bandit_link": "https://www.summertraceatgulfshores.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.summertraceatgulfshores.com?utm_knock=flyers",
  "custom_knock_osoc_number": "251-572-1331",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321233737",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "251-714-1801",
  "custom_knock_cfres_number": "251-357-1632",
  "custom_knock_chatgpt_link": "https://www.summertraceatgulfshores.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "f52be841ae711eef",
  "custom_knock_dirmail_link": "https://www.summertraceatgulfshores.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "251-360-3135",
  "custom_knock_propbro_link": "https://www.summertraceatgulfshores.com?utm_knock=propbro",
  "custom_knock_psocl_number": "251-351-3744",
  "custom_knock_bandit_number": "251-309-7242",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "251-309-7510",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.summertraceatgulfshores.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "251-274-8630",
  "custom_knock_dirmail_number": "251-309-7458",
  "custom_knock_propbro_number": "251-309-7519",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "251-714-1805",
  "custom_knock_maintenance_link": "https://www.summertraceatgulfshores.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192640/019e84b9-e6b1-735e-aaf0-bac9beca0ac3.mp4",
  "custom_knock_maintenance_number": "251-309-7514",
  "custom_ppc_tracking_phone_number": "251-351-0226",
  "custom_audioeye_site_id": "fce2d777-c6b3-491b-8f28-fe94ac1e4124",
  "custom_audioeye_site_hash": "da350fe1facc729c0b1c82155de0760d"
};

export const generatedAt = '2026-11-03T18:20:55.212Z';
